export enum SearchTab {
  ALL = 'all',
  PROJECTS = 'projects',
  REQUESTS = 'requests',
  ASSETS = 'assets',
}
